import {OccasionType} from '../../../gql/pwa/graphql.ts';
import styles from '../occasion_details.module.scss';
import {Table} from '../../../components/table/table.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {TableRow} from '../../../components/table/table_row.tsx';
import {TableCell} from '../../../components/table/table_cell.tsx';
import {__} from '../../../support/lang/translations.ts';
import {formatEuro} from '../../../support/format_currency.ts';
import {ReactElement} from 'react';

interface OwnProps {
    occasion: OccasionType;
}
export function Financial({occasion}: OwnProps) {
    let priceWithVat = null;
    let priceWithoutVat = null;
    let taxDeductible: string | ReactElement = __('general.unknown');

    if (occasion.price && occasion.price > 1) {
        taxDeductible = occasion.price > 1 ? __('general.unknown') : __('general.non_applicable');
        const bpm = occasion.bpm ?? 0;

        if (occasion.tax === 'BTW_EX') {
            priceWithVat = Math.round(occasion.price * 1.21);
            priceWithoutVat = occasion.price;
            taxDeductible = __('general.yes');
        }

        if (occasion.tax === 'BTW_IN') {
            priceWithoutVat = Math.round((occasion.price - bpm) / 1.21 + bpm);
            priceWithVat = occasion.price;
            taxDeductible = __('general.no');
        }
    }

    return (
        <div className={styles.tabs_grid}>
            <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.new_price')}
                        value={occasion.new_price ? formatEuro(occasion.new_price) : '-'}
                    />
                </TableRow>

                {priceWithVat && (
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.price_with_vat')}
                            value={formatEuro(priceWithVat)}
                        />
                    </TableRow>
                )}
                {priceWithoutVat && (
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.price_without_vat')}
                            value={formatEuro(priceWithoutVat)}
                        />
                    </TableRow>
                )}

                <TableRow columns={1}>
                    <TableCell name={__('occasions.details.general_fields.tax_deductible')} value={taxDeductible} />
                </TableRow>
                {occasion.financing && occasion.financing.lease_price && occasion.financing.lease_price > 0 ? (
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.lease_price')}
                            value={formatEuro(occasion.financing.lease_price)}
                        />
                    </TableRow>
                ) : null}
            </Table>
            <Table alignment={Alignment.Start} style={{paddingTop: 0}}>
                <TableRow columns={1}>
                    <TableCell
                        name={__('occasions.details.general_fields.delivery_costs')}
                        value={occasion.delivery_costs ?? '-'}
                    />
                </TableRow>
                {occasion.road_tax_min && occasion.road_tax_max ? (
                    <TableRow columns={1}>
                        <TableCell
                            name={__('occasions.details.general_fields.road_tax')}
                            value={`${formatEuro(occasion.road_tax_min)} ${__('general.till')} ${formatEuro(occasion.road_tax_max)}`}
                        />
                    </TableRow>
                ) : null}
            </Table>
        </div>
    );
}
